export enum TreatmentTimeUnit {
  MINUTES = 'MINUTES',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
